module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui fluid search selection dropdown",
    class: {
      'active visible': _vm.showMenu, 'error': _vm.isError, 'disabled': _vm.isDisabled
    },
    on: {
      "click": _vm.openOptions,
      "focus": _vm.openOptions
    }
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "input",
    staticClass: "search",
    attrs: {
      "autocomplete": "off",
      "tabindex": "0"
    },
    domProps: {
      "value": _vm._s(_vm.searchText)
    },
    on: {
      "focus": function($event) {
        $event.preventDefault();
        _vm.openOptions($event)
      },
      "keyup": [function($event) {
        if (_vm._k($event.keyCode, "esc", 27)) { return; }
        _vm.closeOptions($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.enterItem($event)
      }],
      "blur": _vm.blurInput,
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "up", 38)) { return; }
        _vm.prevItem($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "down", 40)) { return; }
        _vm.nextItem($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
      }, function($event) {
        if (_vm._k($event.keyCode, "delete", [8, 46])) { return; }
        _vm.deleteTextOrItem($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text",
    class: _vm.textClass,
    attrs: {
      "data-vss-custom-attr": _vm.searchTextCustomAttr
    }
  }, [_vm._v(_vm._s(_vm.inputText) + "\n  ")]), _vm._v(" "), _c('div', {
    ref: "menu",
    staticClass: "menu",
    class: _vm.menuClass,
    style: (_vm.menuStyle),
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.filteredOptions), function(option, idx) {
    return [_c('div', {
      staticClass: "item",
      class: {
        'selected': option.selected, 'current': _vm.pointer === idx
      },
      attrs: {
        "data-vss-custom-attr": _vm.customAttrs[idx] ? _vm.customAttrs[idx] : ''
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectItem(option)
        },
        "mousedown": _vm.mousedownItem,
        "mouseenter": function($event) {
          _vm.pointerSet(idx)
        }
      }
    }, [_vm._v("\n        " + _vm._s(option.text) + "\n      ")])]
  })], 2)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3a0c7bea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/ModelSelect.vue
 ** module id = 254
 ** module chunks = 0
 **/